module.exports = __webpack_public_path__ + "static/media/default_clinic.6dce6d0e.svg";